export const categories = [
  { slug: 'live-recordings', name: '直播录屏', icon: 'ri-live-line', count: 128 },
  { slug: 'funny-clips', name: '搞笑片段', icon: 'ri-emotion-laugh-line', count: 96 },
  { slug: 'daily-vlogs', name: '日常Vlog', icon: 'ri-calendar-line', count: 74 },
  { slug: 'highlights', name: '精彩集锦', icon: 'ri-star-line', count: 85 },
  { slug: 'fan-interactions', name: '粉丝互动', icon: 'ri-heart-line', count: 63 },
  { slug: 'latest-news', name: '最新动态', icon: 'ri-flashlight-line', count: 52 },
];

export const featuredVideos = [
  {
    id: 'fv-1',
    slug: 'goutou-luoli-funny-moments-2024',
    title: '狗头萝莉2024年度搞笑名场面合集',
    excerpt: '盘点2024年狗头萝莉直播中最搞笑的经典场面，每一个都让人笑到停不下来！从意外翻车到神级接梗，全程高能不断。',
    category: '搞笑片段',
    categorySlug: 'funny-clips',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20vibrant%20streaming%20studio%20scene%20with%20colorful%20RGB%20lighting%20and%20a%20gaming%20setup%20featuring%20a%20young%20female%20streamer%20laughing%20joyfully%20in%20front%20of%20a%20microphone%20and%20camera%20with%20chat%20messages%20on%20screen%20warm%20and%20energetic%20atmosphere%20with%20soft%20bokeh%20background%20professional%20photography&width=800&height=450&seq=goutou-funny-01&orientation=landscape',
    views: '128.5万',
    date: '2024-12-28',
    duration: '15:32',
  },
  {
    id: 'fv-2',
    slug: 'goutou-luoli-live-highlight-winter',
    title: '狗头萝莉冬季特别直播完整录屏',
    excerpt: '狗头萝莉冬季特别企划直播全程录制，包含粉丝问答环节、游戏挑战、以及独家幕后花絮，温暖你的整个冬天。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20winter%20themed%20streaming%20room%20with%20warm%20fairy%20lights%20and%20knitted%20decorations%20a%20streamer%20setup%20with%20dual%20monitors%20displaying%20gameplay%20and%20chat%20soft%20golden%20lighting%20creating%20a%20comfortable%20and%20inviting%20atmosphere%20editorial%20photography&width=800&height=450&seq=goutou-live-02&orientation=landscape',
    views: '96.3万',
    date: '2024-12-15',
    duration: '2:18:45',
  },
  {
    id: 'fv-3',
    slug: 'goutou-luoli-fan-meeting-2024',
    title: '狗头萝莉2024粉丝见面会全程记录',
    excerpt: '记录狗头萝莉首次线下粉丝见面会的珍贵时刻，包含互动游戏环节、粉丝表白、签名合影等感动瞬间。',
    category: '粉丝互动',
    categorySlug: 'fan-interactions',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fan%20meeting%20event%20scene%20with%20a%20popular%20streamer%20on%20stage%20interacting%20with%20enthusiastic%20audience%20members%20colorful%20stage%20lighting%20and%20decorations%20warm%20and%20exciting%20atmosphere%20large%20banner%20in%20background%20professional%20event%20photography&width=800&height=450&seq=goutou-fan-03&orientation=landscape',
    views: '156.8万',
    date: '2024-11-20',
    duration: '45:18',
  },
];

export const latestVideos = [
  {
    id: 'lv-1',
    slug: 'goutou-new-year-special-2025',
    title: '狗头萝莉2025新年特别直播：跨年倒计时',
    excerpt: '和狗头萝莉一起迎接2025年！跨年夜特别直播，包含年度回顾、新年愿望、粉丝连麦等精彩环节。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20festive%20new%20year%20celebration%20streaming%20scene%20with%20golden%20and%20silver%20decorations%20confetti%20and%20sparkling%20lights%20a%20streaming%20setup%20with%20countdown%20timer%20on%20screen%20joyful%20and%20celebratory%20atmosphere%20warm%20golden%20tones&width=800&height=450&seq=goutou-newyear-01&orientation=landscape',
    views: '89.2万',
    date: '2025-01-01',
    duration: '3:42:15',
  },
  {
    id: 'lv-2',
    slug: 'goutou-luoli-cooking-challenge',
    title: '狗头萝莉厨房挑战：黑暗料理大赏',
    excerpt: '狗头萝莉首次尝试做饭，结果翻车不断！从切菜到调味全程笑料百出，最终成品让人大跌眼镜。',
    category: '搞笑片段',
    categorySlug: 'funny-clips',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20messy%20kitchen%20scene%20with%20a%20young%20female%20content%20creator%20attempting%20to%20cook%20with%20flour%20spilled%20everywhere%20and%20funny%20facial%20expression%20warm%20kitchen%20lighting%20with%20steam%20rising%20from%20pots%20humorous%20and%20chaotic%20atmosphere&width=800&height=450&seq=goutou-cook-02&orientation=landscape',
    views: '112.6万',
    date: '2024-12-25',
    duration: '22:15',
  },
  {
    id: 'lv-3',
    slug: 'goutou-luoli-gaming-marathon',
    title: '狗头萝莉通宵游戏马拉松：恐怖游戏特辑',
    excerpt: '狗头萝莉挑战连续玩10款恐怖游戏！全程尖叫不断，被吓到躲桌子底下，粉丝弹幕笑疯了。',
    category: '精彩集锦',
    categorySlug: 'highlights',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20gaming%20room%20at%20night%20with%20a%20streamer%20reacting%20to%20a%20horror%20game%20on%20a%20large%20monitor%20with%20scary%20gameplay%20visible%20purple%20and%20red%20ambient%20lighting%20creating%20spooky%20atmosphere%20dramatic%20and%20intense%20mood&width=800&height=450&seq=goutou-horror-03&orientation=landscape',
    views: '143.7万',
    date: '2024-12-20',
    duration: '18:42',
  },
  {
    id: 'lv-4',
    slug: 'goutou-luoli-daily-life-vlog',
    title: '狗头萝莉的一天：从起床到直播的日常Vlog',
    excerpt: '带你走进狗头萝莉的日常生活！从早起护肤、健身、准备直播到与粉丝互动，展现最真实的狗头萝莉。',
    category: '日常Vlog',
    categorySlug: 'daily-vlogs',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20lifestyle%20vlog%20aesthetic%20scene%20with%20a%20young%20female%20influencer%20in%20a%20modern%20apartment%20doing%20morning%20routine%20natural%20sunlight%20streaming%20through%20large%20windows%20minimalist%20and%20clean%20interior%20design%20with%20plants%20warm%20and%20cozy%20atmosphere&width=800&height=450&seq=goutou-vlog-04&orientation=landscape',
    views: '76.4万',
    date: '2024-12-18',
    duration: '28:10',
  },
  {
    id: 'lv-5',
    slug: 'goutou-luoli-qa-session',
    title: '狗头萝莉粉丝问答：你们最想知道的事',
    excerpt: '狗头萝莉首次开启真心话模式！回答粉丝最关心的50个问题，从感情生活到未来规划，全程高能。',
    category: '粉丝互动',
    categorySlug: 'fan-interactions',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20QandA%20session%20streaming%20scene%20with%20a%20female%20streamer%20reading%20fan%20questions%20from%20a%20large%20screen%20with%20chat%20messages%20flowing%20colorful%20studio%20lighting%20with%20warm%20tones%20intimate%20and%20engaging%20atmosphere%20professional%20streaming%20setup&width=800&height=450&seq=goutou-qa-05&orientation=landscape',
    views: '201.3万',
    date: '2024-12-10',
    duration: '1:05:30',
  },
  {
    id: 'lv-6',
    slug: 'goutou-luoli-collab-stream',
    title: '狗头萝莉联动特别篇：与好友的欢乐双排',
    excerpt: '狗头萝莉邀请神秘嘉宾一起直播！两人默契配合却频频翻车，欢乐双排变成互坑现场，粉丝直呼太有节目效果了。',
    category: '直播录屏',
    categorySlug: 'live-recordings',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20collaborative%20streaming%20scene%20with%20two%20streamers%20side%20by%20side%20laughing%20and%20playing%20games%20together%20split%20screen%20monitors%20showing%20gameplay%20colorful%20studio%20with%20neon%20accents%20dynamic%20and%20fun%20atmosphere%20warm%20energetic%20lighting&width=800&height=450&seq=goutou-collab-06&orientation=landscape',
    views: '167.9万',
    date: '2024-12-05',
    duration: '1:52:38',
  },
];

export const hotTopics = [
  {
    id: 'ht-1',
    slug: 'goutou-luoli-most-memorable-moments',
    title: '盘点狗头萝莉十大最难忘直播瞬间',
    excerpt: '从出道至今，狗头萝莉创造了许多令人难忘的直播瞬间。让我们一起回顾这些经典时刻，感受她的成长与蜕变。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20montage%20style%20collage%20of%20memorable%20streaming%20moments%20featuring%20a%20female%20streamer%20in%20various%20emotional%20states%20from%20laughing%20to%20surprised%20warm%20cinematic%20lighting%20with%20soft%20gradients%20nostalgic%20and%20heartfelt%20atmosphere&width=600&height=340&seq=goutou-moments-01&orientation=landscape',
    date: '2024-12-22',
    views: '98.6万',
  },
  {
    id: 'ht-2',
    slug: 'goutou-luoli-style-evolution',
    title: '狗头萝莉造型进化史：从青涩到惊艳',
    excerpt: '回顾狗头萝莉从早期直播到现在的造型变化，每一个阶段都见证了她的成长。来看看哪个时期的造型最让你心动？',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fashion%20evolution%20timeline%20concept%20with%20a%20young%20female%20influencer%20in%20different%20stylish%20outfits%20from%20casual%20to%20elegant%20soft%20studio%20lighting%20with%20neutral%20background%20fashion%20editorial%20style%20clean%20and%20sophisticated%20aesthetic&width=600&height=340&seq=goutou-style-02&orientation=landscape',
    date: '2024-12-16',
    views: '85.3万',
  },
  {
    id: 'ht-3',
    slug: 'goutou-luoli-behind-the-scenes',
    title: '狗头萝莉幕后故事：你不知道的直播背后',
    excerpt: '镜头之外的狗头萝莉是什么样的？揭秘直播间的准备工作、团队的日常运作，以及她为每次直播付出的努力。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20view%20of%20a%20streaming%20studio%20with%20equipment%20setup%20cameras%20lights%20and%20a%20team%20preparing%20for%20a%20live%20broadcast%20warm%20documentary%20style%20lighting%20authentic%20and%20candid%20atmosphere%20professional%20production%20environment&width=600&height=340&seq=goutou-bts-03&orientation=landscape',
    date: '2024-12-08',
    views: '72.1万',
  },
];